import React, { FC, useState } from 'react';
import { segmentType } from '../models/segment-type';
import styles from './TowerSegmentSelector.module.css';

export interface TowerSegmentSelectorProps {
    activeSegment: segmentType,
    setActiveSegment: (segmentType: segmentType) => void,
    getSegmentName: (segmentType: segmentType) => string,
}

const TowerSegmentSelector: FC<TowerSegmentSelectorProps> = ({ activeSegment, setActiveSegment, getSegmentName }) => {

    return (
        <div className={styles.TowerSegmentSelector} data-testid="TowerSegmentSelector">
            <div className={styles.amazing}>
                <button className={`${styles.spButton} ${styles.crownsegment}`} onClick={() => setActiveSegment(segmentType.crown)}>
                    <div className={styles.crownbox}>
                        <div className={`${styles.crownelement} ${activeSegment === segmentType.crown ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.crown)}
                    </div>
                </button>
                <button className={`${styles.spButton} ${styles.middlesegment}`} onClick={() => setActiveSegment(segmentType.middle)}>
                    <div className={styles.middlebox}>
                        <div className={`${styles.middleelement} ${activeSegment === segmentType.middle ? styles.active : ''}`}></div>
                        <div className={`${styles.middleelement} ${activeSegment === segmentType.middle ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.middle)}
                    </div>
                </button>
                <button className={`${styles.spButton} ${styles.plinthsegment}`} onClick={() => setActiveSegment(segmentType.plinth)}>
                    <div className={styles.plinthbox}>
                        <div className={`${styles.plinthelement} ${activeSegment === segmentType.plinth ? styles.active : ''}`}></div>
                    </div>
                    <div className={styles.labels}>
                        — {getSegmentName(segmentType.plinth)}
                    </div>
                </button>
            </div>
        </div>
    )
};

export default TowerSegmentSelector;
